<div class="signup-group-builder-wrapper">
  <div *ngIf="!guild">
    <p>Loading...</p>
  </div>

  <div class="row p-2" *ngIf="guild">
    <div class="col-md-12">
      <!-- Form -->
      <form [formGroup]="signupGroupForm" (ngSubmit)="onSubmit()">
        <!-- General -->
        <div class="form-section">
          <h3 class="pb-3">General</h3>
          <div class="row pe-3">
            <div class="col-12 col-md-6 pe-0">
              <!-- Group Name -->
              <mat-form-field appearance="fill" class="full-width-container">
                <mat-label>Group Name</mat-label>
                <input matInput formControlName="signupGroupTitle" />
                <mat-error *ngIf="signupGroupForm.get('signupGroupTitle').errors?.required">This field is
                  required</mat-error>
                <mat-error *ngIf="signupGroupForm.get('signupGroupTitle').errors?.minlength">Title is too short (min.
                  1)</mat-error>
                <mat-error *ngIf="signupGroupForm.get('signupGroupTitle').errors?.maxlength">Title is too long (max.
                  50)</mat-error>
              </mat-form-field>
            </div>
            <div class="col-12 col-md-6 pe-0">
              <mat-form-field class="full-width-container">
                <mat-label>Signup Template</mat-label>
                <mat-select id="signupTemplates" name="signupTemplates" formControlName="signupTemplate">
                  <ng-container *ngFor="let template of signupTemplates">
                    <mat-option [value]="template.identifier">
                      {{ template.name }}
                    </mat-option>
                  </ng-container>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
        </div>
        <!-- General End -->
        <!-- User Selection -->
        <div class="form-section" *ngIf="selectedSignupTemplate">
          <!-- User Selection -->
          <h3 class="pb-3">User Selection</h3>
          <div [formGroup]="userSelections" class="row">
            <div class="col-12" *ngFor="let emoji of parsedEmojis">
              <h5>{{ emoji.fieldName }}</h5>
              <!-- Main Emoji (Only if no sub-emojis) -->
              <div *ngIf="!emoji.subEmojis?.length">
                <mat-form-field class="full-width-container">
                  <mat-label>{{ emoji.fieldName }}</mat-label>
                  <mat-select [formControlName]="emoji.controlName" multiple>
                    <mat-option>
                      <ngx-mat-select-search [formControl]="memberFilter"></ngx-mat-select-search>
                    </mat-option>
                    <!-- Make previous selected users still selectable but disable new members if limit is reached -->
                    <mat-option *ngFor="let member of filteredMembers" [value]="member.user_id" [disabled]="
                        !userSelections.get(emoji.controlName)?.value.includes(member.user_id) &&
                        !canSelectMore(emoji.controlName)
                      ">
                      {{ member.display_name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <!-- Sub Emojis -->
              <div *ngIf="emoji.subEmojis?.length">
                <div *ngFor="let subEmoji of emoji.subEmojis">
                  <mat-form-field class="full-width-container">
                    <mat-label>{{ subEmoji.fieldName }}</mat-label>
                    <mat-select [formControlName]="subEmoji.controlName" multiple>
                      <mat-option>
                        <ngx-mat-select-search [formControl]="memberFilter"></ngx-mat-select-search>
                      </mat-option>
                      <mat-option *ngFor="let member of filteredMembers" [value]="member.user_id" [disabled]="
                          !userSelections.get(subEmoji.controlName)?.value.includes(member.user_id) &&
                          !canSelectMore(subEmoji.controlName)
                        ">
                        {{ member.display_name }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- User Selection End -->
        <!-- Action Buttons -->
        <div class="action-buttons-container">
          <div class="primary-actions">
            <button mat-raised-button color="primary" type="submit" [disabled]="!signupGroupForm.valid" class="save-button">
              <mat-icon>{{ signupGroupId === null ? 'add' : 'save' }}</mat-icon>
              <span>{{ signupGroupId === null ? 'Create Signup Group' : 'Save Signup Group' }}</span>
            </button>
          </div>
          <div class="secondary-actions" *ngIf="signupGroupId !== null">
            <button mat-stroked-button color="warn" type="button" (click)="deleteGroup()" class="delete-button">
              <fa-icon [icon]="faIcons.trash"></fa-icon>
              <span> Delete Signup Group</span>
            </button>
          </div>
        </div>
      </form>
      <!-- Form End -->
    </div>
  </div>
</div>
